import { ICmxTrackingNumberList } from '../../types/types';
import authService from '../../components/api-authorization/AuthorizeService';

export const getClaimantStatusByIdListAsync = async (trackingNumbers: ICmxTrackingNumberList) => {
	

	try {
		let headers = new Headers({
			'Content-Type': 'application/json'			
		});

		let response = await fetch(`api/cmx/claimStatus/`, {
			method: 'POST',
			headers: headers,
			body: JSON.stringify(trackingNumbers)
		});

		if (!response.ok) {
			throw new Error("Failed to retrieve Cmx claimant status");
		}

		const res = await response.json();
		return res;
	}

	catch (error) {
		console.error(error);
		throw error;
	}
}

export const getValidCmxAccountTypes = async (cmxCaseNumber: number) => {
	

	try {
		let headers = new Headers({
			'Content-Type': 'application/json'			
		});

		let response = await fetch(`api/cmx/getValidCmxAccountTypes/`, {
			method: 'POST',
			headers: headers,
			body: JSON.stringify(cmxCaseNumber)
		});

		if (response.status === 204) {
			console.log('No Cmx account types returned');
			return null; 
		}

		if (!response.ok) {
			throw new Error("Failed to retrieve Cmx account types");
		}

		const res = await response.json();
		return res;
	}

	catch (error) {
		console.error(error);
		throw error;
	}

}

